import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=214af9ea&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=214af9ea&lang=scss&scoped=true&"
import style1 from "./NotificationsDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214af9ea",
  null
  
)

export default component.exports